module.exports = __webpack_public_path__ + "static/media/Train.876a869a.svg";